// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-modal {
  max-width: 98vw;
  width: 98vw;
  max-height: calc(100vh - 40px); /* Allow expansion but leave margin for viewport */
  min-height: 50vh; /* Ensure minimum usable height */
  overflow-y: auto; /* Show scrollbar only if content exceeds viewport */
}

/* Two-column layout for edit page */
.edit-content-layout {
  display: flex !important;
  flex-direction: row !important;
  gap: 0; /* Remove gap to accommodate resize handle */
  min-height: 600px; /* Keep minimum height for usability */
  max-height: none; /* Remove height restriction to allow auto-expansion */
  position: relative; /* For overlay positioning */
}

/* Prevent text selection and pointer events during resize */
.edit-content-layout.resizing {
  -webkit-user-select: none;
          user-select: none;
  cursor: col-resize !important;
}

.edit-content-layout.resizing * {
  -webkit-user-select: none;
          user-select: none;
  pointer-events: none !important;
}

/* Keep the resize handle interactive during resize */
.edit-content-layout.resizing .resize-handle {
  pointer-events: auto !important;
}

/* Add overlay during resize to capture all mouse events */
.edit-content-layout.resizing::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  cursor: col-resize;
  pointer-events: auto;
}

.edit-preview-section {
  display: flex;
  flex-direction: column;
  padding-right: 20px;
  min-width: 0;
  overflow: hidden;
}

.edit-preview-section h3 {
  margin: 0 0 15px 0;
  color: #333;
  font-size: 16px;
  font-weight: bold;
}

.edit-form-section {
  display: flex;
  flex-direction: column;
  min-width: 0;
  max-height: calc(100vh - 120px); /* Constrain to viewport height minus modal padding */
  overflow-y: auto; /* Enable scrolling when content exceeds height */
}

/* Resize handle between preview and form sections */
.resize-handle {
  width: 8px;
  background-color: #e9ecef;
  cursor: col-resize;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
  transition: background-color 0.2s ease;
  flex: 0 0 8px;
}

.resize-handle:hover {
  background-color: #007bff;
}

.resize-handle-line {
  width: 2px;
  height: 40px;
  background-color: #6c757d;
  border-radius: 1px;
  pointer-events: none;
}

.resize-handle:hover .resize-handle-line {
  background-color: white;
}

/* Resize handle between preview and form sections */
.resize-handle {
  width: 8px;
  background-color: #e9ecef;
  cursor: col-resize;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
  transition: background-color 0.2s ease;
  flex: 0 0 8px;
}

.resize-handle:hover {
  background-color: #007bff;
}

.resize-handle-line {
  width: 2px;
  height: 40px;
  background-color: #6c757d;
  border-radius: 1px;
  pointer-events: none;
}

.resize-handle:hover .resize-handle-line {
  background-color: white;
}

/* Document preview toggle */
.document-preview-toggle {
  margin-bottom: 20px;
  text-align: center;
}

.preview-toggle-btn {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 10px 20px;
  font-size: 14px;
  color: #495057;
  cursor: pointer;
  transition: all 0.2s ease;
}

.preview-toggle-btn:hover {
  background-color: #e9ecef;
  border-color: #adb5bd;
}

/* Document preview section (when expanded) */
.document-preview-section {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  height: 400px;
  display: flex;
  flex-direction: column;
}

.document-preview-container {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-height: 0; /* Allow iframe to shrink */
  height: 100%;
}

.document-preview-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  gap: 8px;
}

.pdf-viewer-container {
  flex: 1 1;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #f5f5f5;
  min-height: 300px;
  position: relative;
}

.document-preview-embed {
  width: 100%;
  height: 100%;
  min-height: 300px;
  border: none;
  border-radius: 4px;
}

.pdf-fallback-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  text-align: center;
  color: #666;
  padding: 20px;
}

.pdf-fallback-message p {
  margin: 8px 0;
}

.preview-fallback-actions {
  display: flex;
  gap: 8px;
  justify-content: center;
  padding: 8px;
}

.open-pdf-btn,
.download-pdf-btn {
  padding: 6px 12px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  text-decoration: none;
  font-size: 12px;
  transition: background-color 0.2s;
}

.open-pdf-btn:hover,
.download-pdf-btn:hover {
  background-color: #0056b3;
}

.download-pdf-btn {
  background-color: #28a745;
}

.download-pdf-btn:hover {
  background-color: #1e7e34;
}

.preview-loading,
.preview-error,
.no-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1 1;
  text-align: center;
  padding: 40px;
  background-color: #ffffff;
  border: 1px dashed #ccc;
  border-radius: 4px;
  color: #666;
}

.retry-preview-btn,
.load-preview-btn {
  margin-top: 10px;
  padding: 8px 16px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.retry-preview-btn:hover,
.load-preview-btn:hover {
  background-color: #0056b3;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .document-preview-section {
    height: 300px;
  }

  .document-preview-iframe {
    min-height: 250px;
  }
}

.edit-form {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.form-section {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 20px;
}

/* Constrain supporting sections but allow payroll form to use full width */
.form-section.document-info-section,
.form-section.metadata-history-section {
  margin: 0 auto;
  max-width: 800px;
  flex: 0 0 auto; /* Prevent flex growing to fill available space */
}

/* Keep WH-347 form at full width with horizontal scroll */
.form-section.payroll-form-section {
  width: 100%;
  max-width: none;
  overflow-x: auto; /* Enable horizontal scroll for wide tables */
}

/* Collapsible section styles */
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  margin-bottom: 15px;
  padding: 10px 0;
  border-bottom: 2px solid #007bff;
}

.section-header:hover {
  background-color: rgba(0, 123, 255, 0.05);
  border-radius: 4px;
  padding: 10px 8px;
  margin: 0 -8px 15px -8px;
}

.section-header h3 {
  margin: 0;
  color: #495057;
  font-size: 18px;
  font-weight: 600;
  border-bottom: none;
  padding-bottom: 0;
}

.collapse-icon {
  font-size: 14px;
  transition: transform 0.2s ease;
  color: #007bff;
  font-weight: bold;
}

.collapse-icon.collapsed {
  transform: rotate(90deg);
}

.section-content {
  animation: slideDown 0.2s ease-out;
}

/* Only enable horizontal scroll for payroll form content */
.payroll-form-section .section-content {
  overflow-x: auto; /* Enable horizontal scroll for wide tables */
}

@keyframes slideDown {
  from {
    opacity: 0;
    max-height: 0;
    overflow: hidden;
  }
  to {
    opacity: 1;
    max-height: none;
    overflow: visible;
  }
}

/* Vertical resize handles for sections */
.section-resize-handle {
  height: 8px;
  background-color: #f8f9fa;
  cursor: row-resize;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
  transition: background-color 0.2s ease;
  margin: 5px 0;
}

.section-resize-handle:hover {
  background-color: #007bff;
}

.section-resize-line {
  width: 40px;
  height: 2px;
  background-color: #6c757d;
  border-radius: 1px;
  pointer-events: none;
}

.section-resize-handle:hover .section-resize-line {
  background-color: white;
}

/* Modal header improvements */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header-controls {
  display: flex;
  align-items: center;
  gap: 10px;
}

.help-tooltip {
  font-size: 16px;
  cursor: help;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.help-tooltip:hover {
  opacity: 1;
}

/* Legacy h3 styles for non-collapsible sections */
.form-section h3:not(.section-header h3) {
  margin: 0 0 20px 0;
  color: #495057;
  font-size: 18px;
  font-weight: 600;
  border-bottom: 2px solid #007bff;
  padding-bottom: 8px;
}

.form-group {
  margin-bottom: 20px;
}

/* Document Information section layout */
.form-section:first-of-type .form-group {
  margin-bottom: 15px;
}

.form-section:first-of-type h3 {
  margin-bottom: 15px;
}

/* Create a 2-column layout for document info fields */
.document-info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.document-info-full-width {
  grid-column: 1 / -1;
}

.form-group label {
  display: block;
  font-weight: bold;
  color: #495057;
  margin-bottom: 5px;
  font-size: 14px;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
  background-color: white;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-sizing: border-box;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.form-group textarea {
  resize: vertical;
  min-height: 80px;
}

.metadata-description {
  font-size: 14px;
  color: #6c757d;
  margin-bottom: 15px;
  font-style: italic;
}

.metadata-form {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 15px;
  padding: 10px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  background-color: #ffffff;
}

.metadata-display {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.metadata-item {
  background-color: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 15px;
  font-size: 14px;
  line-height: 1.5;
}

.metadata-item strong {
  color: #495057;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  padding-top: 20px;
  border-top: 1px solid #dee2e6;
  margin-top: 10px;
}

.cancel-btn {
  padding: 10px 20px;
  border: 1px solid #6c757d;
  background-color: #ffffff;
  color: #6c757d;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.15s ease-in-out;
}

.cancel-btn:hover {
  background-color: #6c757d;
  color: white;
}

.submit-btn {
  padding: 10px 20px;
  border: none;
  background-color: #007bff;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.15s ease-in-out;
}

.submit-btn:hover:not(:disabled) {
  background-color: #0056b3;
}

.submit-btn:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

/* Reject button styling */
.reject-btn {
  padding: 10px 20px;
  border: none;
  background-color: #dc3545;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.15s ease-in-out;
}

.reject-btn:hover:not(:disabled) {
  background-color: #c82333;
}

.reject-btn:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

/* Approve button styling */
.approve-btn {
  padding: 10px 20px;
  border: none;
  background-color: #28a745;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.15s ease-in-out;
}

.approve-btn:hover:not(:disabled) {
  background-color: #218838;
}

.approve-btn:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

/* Save Correction Comments button styling */
.save-comments-section {
  margin-top: 10px;
  margin-bottom: 0;
}

.save-comments-btn {
  background-color: #17a2b8;
  color: white;
  border: none;
  padding: 8px 16px;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  font-weight: 500;
}

.save-comments-btn:hover:not(:disabled) {
  background-color: #138496;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.save-comments-btn:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

/* Correction comments display styling */
.correction-comments-list {
  margin-top: 8px;
  margin-left: 10px;
}

.correction-comment-item {
  background-color: #f8f9fa;
  border-left: 3px solid #17a2b8;
  padding: 8px 12px;
  margin-bottom: 8px;
  border-radius: 0 4px 4px 0;
}

.correction-comment-item:last-child {
  margin-bottom: 0;
}

.comment-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
  font-size: 12px;
  color: #6c757d;
}

.comment-user {
  font-weight: 600;
  color: #495057;
}

.comment-timestamp {
  font-style: italic;
}

.comment-text {
  color: #495057;
  line-height: 1.4;
  font-size: 14px;
}

/* Read-only field styling */
.readonly-field {
  padding: 10px 12px;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  color: #495057;
  font-size: 14px;
}

/* Status badge styling */
.status-badge {
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  display: inline-block;
  min-width: 60px; /* Ensure consistent minimum width */
  text-align: center; /* Center text within badge */
}

.status-badge.processing {
  background-color: #007bff;
  color: white;
}

.status-badge.approved {
  background-color: #28a745;
  color: white;
}

.status-badge.rejected {
  background-color: #dc3545;
  color: white;
}

.status-badge.review_required {
  background-color: #ffc107;
  color: #212529;
}

.status-badge.error {
  background-color: #dc3545;
  color: white;
}

/* Review history styling */
.review-history {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 12px;
  max-height: 300px; /* Limit height to prevent excessive expansion */
  overflow-y: auto; /* Enable scrolling for long review histories */
}

.review-entry {
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #dee2e6;
}

.review-entry:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.review-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.review-status {
  font-weight: 600;
  color: #495057;
}

.review-date {
  font-size: 12px;
  color: #6c757d;
}

.review-comments {
  font-size: 14px;
  color: #495057;
  margin-bottom: 4px;
}

.correction-comments {
  font-size: 14px;
  color: #495057;
  font-style: italic;
}

.reviewer-info {
  margin-top: 4px;
}

.reviewer-info small {
  color: #6c757d;
  font-size: 12px;
}

/* Correction comments section styling */
.correction-comments-section {
  border-top: 2px solid #dee2e6;
  margin-top: 20px;
  padding-top: 20px;
}

.correction-comments-field {
  margin-bottom: 0;
}

/* WH-347 Form Specific Styles */
.wh347-form {
  max-width: none;
}

.form-header {
  text-align: center;
  margin-bottom: 30px;
  padding: 20px;
  background-color: #f8f9fa;
  border: 2px solid #007bff;
  border-radius: 8px;
}

.form-header h3 {
  margin: 0;
  color: #007bff;
  font-size: 20px;
  font-weight: bold;
}

.project-info {
  background-color: #e7f1ff;
  border-left: 4px solid #007bff;
}

.employees-section {
  background-color: #fff5e6;
  border-left: 4px solid #ffc107;
}

.signature-section {
  background-color: #e8f5e8;
  border-left: 4px solid #28a745;
}

.form-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 15px;
  margin-bottom: 15px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.section-header h4, .section-header h6 {
  margin: 0;
  color: #495057;
}

.add-employee-btn, .add-day-btn {
  padding: 8px 16px;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.15s ease-in-out;
}

.add-employee-btn:hover, .add-day-btn:hover {
  background-color: #218838;
}

.employee-card {
  background-color: white;
  border: 2px solid #dee2e6;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.employee-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #ffc107;
}

.employee-header h5 {
  margin: 0;
  color: #495057;
  font-size: 16px;
  font-weight: bold;
}

.remove-employee-btn {
  padding: 6px 12px;
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: background-color 0.15s ease-in-out;
}

.remove-employee-btn:hover {
  background-color: #c82333;
}

.employee-info, .pay-info-section, .deductions-section {
  margin-bottom: 20px;
}

.days-worked-section {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 15px;
  margin-bottom: 20px;
}

.day-worked-row {
  display: grid;
  grid-template-columns: 120px 150px 1fr 1fr;
  gap: 10px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: white;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

.pay-info-section h6, .deductions-section h6 {
  margin: 0 0 15px 0;
  color: #495057;
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.generic-metadata-form {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 15px;
}

.contractor-selection {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 15px;
  margin-bottom: 20px;
}

.radio-group {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.radio-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: normal;
  cursor: pointer;
  padding: 8px 12px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  background-color: white;
  transition: all 0.15s ease-in-out;
}

.radio-label:hover {
  background-color: #f8f9fa;
  border-color: #007bff;
}

.radio-label input[type="radio"] {
  width: auto;
  margin: 0;
  padding: 0;
}

.radio-label input[type="radio"]:checked + span,
.radio-label:has(input[type="radio"]:checked) {
  background-color: #007bff;
  color: white;
  border-color: #007bff;
}

/* Responsive design */
@media (max-width: 768px) {
  .edit-modal {
    width: 98%;
    max-height: 95vh;
  }

  .form-section {
    padding: 15px;
  }

  .form-section h3 {
    font-size: 16px;
  }

  .form-actions {
    flex-direction: column;
  }

  .cancel-btn,
  .submit-btn {
    width: 100%;
    padding: 12px;
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .day-worked-row {
    grid-template-columns: 1fr;
  }

  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .employee-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
}

.help-text {
  display: block;
  font-size: 12px;
  color: #666;
  margin-top: 4px;
  line-height: 1.4;
}

/* Legacy WH-347 Form Styles */
.wh347-legacy-form {
  background: #f9f9f9;
  padding: 20px;
  font-family: Arial, sans-serif;
}

.legacy-header {
  margin-bottom: 20px;
  text-align: center;
}

.project-info-legacy {
  margin: 0 auto 20px auto;
  padding: 15px;
  background: white;
  border: 1px solid #ddd;
  max-width: 800px;
  border-radius: 4px;
}

.wh347-legacy-table {
  width: 100%;
  min-width: 800px; /* Ensure minimum width to trigger horizontal scroll */
  border-collapse: collapse;
  margin: 20px 0;
  background: white;
  font-size: 12px;
}

.wh347-legacy-table th,
.wh347-legacy-table td {
  border: 1px solid #000;
  padding: 2px;
  vertical-align: top;
  position: relative;
}

/* Specific cell width constraints to prevent overflow */
.name-title-col {
  width: 200px;
  min-width: 150px;
}

.hours-rate-col {
  width: 140px;
  min-width: 100px;
}

.wh347-legacy-table th {
  background: #f0f0f0;
  font-weight: bold;
  text-align: center;
}

.day-header-table,
.deduction-header-table,
.legacy-hours-table,
.legacy-rate-table,
.legacy-benefit-table,
.legacy-deductions-table {
  width: 100%;
  border-collapse: collapse;
}

.day-header-table td,
.deduction-header-table td {
  border: 1px solid #ccc;
  padding: 2px;
  text-align: center;
  font-size: 10px;
}

.legacy-name-input,
.legacy-title-input,
.legacy-ssn-input,
.legacy-exemptions-input,
.legacy-daily-hours,
.legacy-hours-input,
.legacy-rate-input,
.legacy-wages-input,
.legacy-deduction,
.legacy-gross-other,
.legacy-net-pay,
.legacy-note-input {
  width: 100%;
  border: 1px solid #ccc;
  padding: 2px;
  font-size: 11px;
  margin: 0;
  box-sizing: border-box;
  min-width: 0;
}

/* Dynamic sizing inputs using character width units */
.legacy-daily-hours {
  width: max(4ch, 35px);
  min-width: 60px;
  max-width: 120px;
  box-sizing: border-box;
}

.legacy-ssn-input,
.legacy-exemptions-input {
  width: max(4ch, 40px);
  min-width: 60px;
  max-width: 80px;
  box-sizing: border-box;
}

.legacy-hours-input {
  width: max(6ch, 60px);
  min-width: 80px;
  max-width: 120px;
  box-sizing: border-box;
}

.legacy-rate-input,
.legacy-wages-input {
  width: max(7ch, 70px);
  min-width: 90px;
  max-width: 140px;
  box-sizing: border-box;
}

.legacy-deduction {
  width: max(5ch, 50px);
  min-width: 30px;
  max-width: 90px;
  box-sizing: border-box;
}

.legacy-benefit-input {
  width: max(4ch, 45px);
  min-width: 55px;
  max-width: 80px;
  box-sizing: border-box;
}

.legacy-gross-other {
  width: max(5ch, 50px);
  min-width: 60px;
  max-width: 90px;
  box-sizing: border-box;
}

.legacy-net-pay {
  width: max(7ch, 70px);
  min-width: 100px;
  max-width: 150px;
  box-sizing: border-box;
}

/* Specific adjustments for name and title fields that tend to overflow */
.legacy-name-input {
  min-height: 20px;
}

.legacy-title-input {
  min-height: 20px;
}

.hour-type-label,
.rate-type-label {
  font-weight: bold;
  text-align: center;
  width: 20px;
}

.total-hours,
.gross-pay,
.total-deductions {
  font-weight: bold;
  text-align: right;
}

.project-label {
  text-align: right;
  font-size: 10px;
}

.hours-worked-label {
  text-align: center;
  font-size: 10px;
  margin-top: 5px;
  font-weight: bold;
}

.legacy-employee-management {
  margin: 20px 0;
  text-align: center;
}

.legacy-add-btn,
.legacy-clear-btn,
.legacy-remove-btn {
  background: #4CAF50;
  color: white;
  border: none;
  padding: 8px 15px;
  margin: 0 5px;
  cursor: pointer;
  border-radius: 3px;
}

.legacy-remove-btn {
  background: #f44336;
  padding: 4px 8px;
  font-size: 10px;
}

.legacy-additional-options {
  margin: 20px auto 0 auto;
  padding: 15px;
  background: white;
  border: 1px solid #ddd;
  max-width: 800px;
  border-radius: 4px;
}

/* Project Information form layout */
.project-info-legacy .form-row {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 15px;
}

.project-info-legacy .form-group {
  flex: 1 1;
  min-width: 200px;
}

.project-info-legacy .form-group label {
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
  font-size: 12px;
}

.project-info-legacy .form-group input,
.project-info-legacy .form-group select {
  width: 100%;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 3px;
  font-size: 12px;
}

/* Additional Options form layout */
.legacy-additional-options .form-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 15px;
}

.legacy-additional-options .checkbox-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.legacy-additional-options .checkbox-group input[type="checkbox"] {
  width: auto;
}

.legacy-additional-options .form-group {
  width: 100%;
}

.legacy-additional-options .form-group label {
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
  font-size: 12px;
}

.legacy-additional-options .form-group textarea {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 3px;
  font-size: 12px;
  resize: vertical;
}

.legacy-gross-summary {
  width: 100%;
  font-size: 10px;
  margin-top: 10px;
}

.legacy-gross-summary td {
  padding: 2px;
  border: 1px solid #ccc;
}

.summary-header {
  font-weight: bold;
  text-align: center;
}

.note-section {
  margin-top: 5px;
  font-size: 10px;
}

.legacy-label {
  font-size: 10px;
  font-weight: bold;
}

/* Auto-calculation prompt modal styles */
.calculation-prompt-overlay {
  z-index: 2000; /* Higher than main modal */
}

.calculation-prompt-modal {
  max-width: 500px;
  width: 90%;
  background: white;
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.calculation-prompt-modal .modal-header {
  background-color: #007bff;
  color: white;
  border-radius: 8px 8px 0 0;
}

.calculation-prompt-modal .modal-header h3 {
  margin: 0;
  font-size: 18px;
}

.calculation-prompt-modal .close-button {
  color: white;
}

.calculation-prompt-modal .close-button:hover {
  color: #fff;
  opacity: 0.8;
}

.calculation-preview {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 15px;
  margin: 15px 0;
}

.calculation-preview ul {
  margin: 10px 0 0 0;
  padding-left: 20px;
}

.calculation-preview li {
  margin: 5px 0;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  transition: background-color 0.2s ease;
}

.btn-primary {
  background-color: #007bff;
  color: white;
}

.btn-primary:hover {
  background-color: #0056b3;
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
}

.btn-secondary:hover {
  background-color: #545b62;
}

/* Legacy gross pay input styling */
.legacy-gross-input {
  width: 60px;
  padding: 2px 4px;
  border: 1px solid #ccc;
  border-radius: 2px;
  font-size: 11px;
  text-align: right;
  background-color: #fff;
}

.legacy-gross-input:focus {
  border-color: #007bff;
  outline: none;
  background-color: #f8f9fa;
}

/* New CSS classes for API schema field mapping */
/* Wage inputs - larger for monetary values */
.legacy-ot-wages-input,
.legacy-std-wages-input {
  width: max(7ch, 70px);
  min-width: 90px;
  max-width: 140px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  padding: 2px;
  font-size: 11px;
  margin: 0;
}

/* Deduction inputs - medium sized for smaller values */
.legacy-deduction-fica,
.legacy-deduction-witholdingTax,
.legacy-deduction-other,
.legacy-deduction-healthInsurance,
.legacy-deduction-retirement_401k {
  width: max(4ch, 50px);
  min-width: 60px;
  max-width: 90px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  padding: 2px;
  font-size: 11px;
  margin: 0;
}

/* Responsive design for edit layout */
@media (max-width: 768px) {
  .edit-content-layout {
    flex-direction: column !important;
    height: auto;
  }

  .edit-preview-section {
    border-right: none;
    border-bottom: 1px solid #dee2e6;
    padding-right: 0;
    padding-bottom: 20px;
    margin-bottom: 20px;
  }

  .document-preview-iframe {
    height: 400px;
  }

  .calculation-prompt-modal {
    max-width: 95%;
  }

  .modal-actions {
    flex-direction: column;
  }

  .btn {
    width: 100%;
    margin: 5px 0;
  }
}

/* Validation Error Highlighting Styles */
.field-error {
  border: 2px solid #dc3545 !important;
  background-color: #f8d7da !important;
  color: #721c24 !important;
}

.field-error-label {
  color: #dc3545 !important;
  font-weight: bold;
}

.field-error-icon {
  color: #dc3545;
  margin-left: 5px;
  font-weight: bold;
}

.validation-error-summary {
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  border-radius: 4px;
  padding: 10px;
  margin-bottom: 15px;
  color: #721c24;
}

.validation-error-summary h5 {
  color: #721c24;
  margin-bottom: 10px;
  font-size: 14px;
}

.validation-error-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.validation-error-list li {
  padding: 2px 0;
  font-size: 12px;
}

.validation-error-list li:before {
  content: "⚠ ";
  color: #dc3545;
  font-weight: bold;
}

/* Upload-result styling for error messages (matching DocumentUpload.css) */
.upload-result {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 15px;
  border-radius: 4px;
  margin-top: 15px;
}

.upload-result.success {
  background: #d4edda;
  border: 1px solid #c3e6cb;
  color: #155724;
}

.upload-result.error {
  background: #f8d7da;
  border: 1px solid #f5c6cb;
  color: #721c24;
}

.result-icon {
  font-size: 16px;
  margin-top: 2px;
}

.result-message {
  flex: 1 1;
}

/* Button-result styling for status display near action buttons */
.button-result {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px;
  border-radius: 4px;
  margin-top: 10px;
  font-size: 14px;
}

.button-result.success {
  background: #d4edda;
  border: 1px solid #c3e6cb;
  color: #155724;
}

.button-result.error {
  background: #f8d7da;
  border: 1px solid #f5c6cb;
  color: #721c24;
}

.result-details {
  font-size: 12px;
  margin-top: 5px;
  opacity: 0.8;
}

/* Validation error categories styling */
.validation-category {
  margin-bottom: 15px;
}

.validation-category h6 {
  margin: 0 0 8px 0;
  font-weight: bold;
  font-size: 14px;
  color: #721c24;
}

.validation-category ul {
  margin: 0;
  padding-left: 20px;
  list-style: none;
}

.validation-category li {
  padding: 2px 0;
  font-size: 13px;
  color: #721c24;
}

.validation-category li:before {
  content: "• ";
  color: #dc3545;
  font-weight: bold;
}

/* Rule Replacement Notifications */
.rule-notification {
  background-color: #d1ecf1;
  border: 1px solid #bee5eb;
  border-radius: 4px;
  padding: 8px 12px;
  margin-top: 4px;
  font-size: 12px;
  color: #0c5460;
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  animation: slideInDown 0.3s ease-out;
}

.rule-notification.just-created {
  background-color: #d4edda;
  border-color: #c3e6cb;
  color: #155724;
}

.rule-notification-icon {
  font-size: 14px;
  flex-shrink: 0;
}

.rule-notification-content {
  flex: 1 1;
  line-height: 1.3;
}

.rule-notification-original {
  text-decoration: line-through;
  color: #6c757d;
  font-weight: normal;
}

.rule-notification-mapped {
  font-weight: 600;
  color: #0c5460;
}

.rule-notification.just-created .rule-notification-mapped {
  color: #155724;
}

.rule-notification-dismiss {
  background: none;
  border: none;
  color: #6c757d;
  cursor: pointer;
  padding: 0;
  font-size: 14px;
  line-height: 1;
  flex-shrink: 0;
  margin-left: 4px;
}

.rule-notification-dismiss:hover {
  color: #495057;
}

@keyframes slideInDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Parsing Notes Styles */
.parsing-notes-group {
  margin-bottom: 20px;
}

.parsing-notes-group label {
  color: #2c3e50;
  font-weight: 600;
  margin-bottom: 8px;
  display: block;
}

.parsing-notes-container {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 12px;
  max-height: 200px;
  overflow-y: auto;
}

.parsing-note {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
  padding: 6px 8px;
  background: white;
  border-radius: 4px;
  border-left: 3px solid #17a2b8;
  box-shadow: 0 1px 2px rgba(0,0,0,0.1);
}

.parsing-note:last-child {
  margin-bottom: 0;
}

.note-index {
  color: #6c757d;
  font-weight: 600;
  margin-right: 8px;
  flex-shrink: 0;
  min-width: 20px;
  font-size: 12px;
}

.note-text {
  color: #495057;
  line-height: 1.4;
  font-size: 14px;
  word-break: break-word;
}

/* Special styling for different types of notes */
.parsing-note-error {
  border-left-color: #dc3545 !important;
}

.parsing-note-warning {
  border-left-color: #ffc107 !important;
}

.parsing-note-success {
  border-left-color: #28a745 !important;
}

.parsing-note-info {
  border-left-color: #17a2b8 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/EditDocument.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,8BAA8B,EAAE,kDAAkD;EAClF,gBAAgB,EAAE,iCAAiC;EACnD,gBAAgB,EAAE,oDAAoD;AACxE;;AAEA,oCAAoC;AACpC;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,MAAM,EAAE,4CAA4C;EACpD,iBAAiB,EAAE,sCAAsC;EACzD,gBAAgB,EAAE,sDAAsD;EACxE,kBAAkB,EAAE,4BAA4B;AAClD;;AAEA,4DAA4D;AAC5D;EACE,yBAAiB;UAAjB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,yBAAiB;UAAjB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA,qDAAqD;AACrD;EACE,+BAA+B;AACjC;;AAEA,0DAA0D;AAC1D;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,+BAA+B,EAAE,qDAAqD;EACtF,gBAAgB,EAAE,iDAAiD;AACrE;;AAEA,oDAAoD;AACpD;EACE,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,+BAA+B;EAC/B,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,oDAAoD;AACpD;EACE,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,+BAA+B;EAC/B,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,6CAA6C;AAC7C;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa,EAAE,2BAA2B;EAC1C,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,YAAY;AACd;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,iCAAiC;AACnC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;EACP,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA,2EAA2E;AAC3E;;EAEE,cAAc;EACd,gBAAgB;EAChB,cAAc,EAAE,iDAAiD;AACnE;;AAEA,0DAA0D;AAC1D;EACE,WAAW;EACX,eAAe;EACf,gBAAgB,EAAE,6CAA6C;AACjE;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;AACpC;;AAEA,2DAA2D;AAC3D;EACE,gBAAgB,EAAE,6CAA6C;AACjE;;AAEA;EACE;IACE,UAAU;IACV,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;EAChC,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,wEAAwE;EACxE,sBAAsB;AACxB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA,wCAAwC;AACxC;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe,EAAE,oCAAoC;EACrD,kBAAkB,EAAE,6BAA6B;AACnD;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,iBAAiB,EAAE,gDAAgD;EACnE,gBAAgB,EAAE,+CAA+C;AACnE;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,wCAAwC;AACxC;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB,EAAE,sDAAsD;EACxE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,wDAAwD;AACxD;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;;;EAME,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;;;;;;;;;;EAYE,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,SAAS;EACT,sBAAsB;EACtB,YAAY;AACd;;AAEA,sDAAsD;AACtD;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,yEAAyE;AACzE;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;;;EAGE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;EAGE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,yCAAyC;AACzC;EACE,aAAa,EAAE,2BAA2B;AAC5C;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,yBAAyB;AAC3B;;AAEA,iDAAiD;AACjD,6CAA6C;AAC7C;;EAEE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,SAAS;AACX;;AAEA,uDAAuD;AACvD;;;;;EAKE,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,SAAS;AACX;;AAEA,sCAAsC;AACtC;EACE;IACE,iCAAiC;IACjC,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;IAChC,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;AACF;;AAEA,yCAAyC;AACzC;EACE,oCAAoC;EACpC,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA,wCAAwC;AACxC;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA,mCAAmC;AACnC;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,UAAU;EACV,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA,iDAAiD;AACjD;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC","sourcesContent":[".edit-modal {\n  max-width: 98vw;\n  width: 98vw;\n  max-height: calc(100vh - 40px); /* Allow expansion but leave margin for viewport */\n  min-height: 50vh; /* Ensure minimum usable height */\n  overflow-y: auto; /* Show scrollbar only if content exceeds viewport */\n}\n\n/* Two-column layout for edit page */\n.edit-content-layout {\n  display: flex !important;\n  flex-direction: row !important;\n  gap: 0; /* Remove gap to accommodate resize handle */\n  min-height: 600px; /* Keep minimum height for usability */\n  max-height: none; /* Remove height restriction to allow auto-expansion */\n  position: relative; /* For overlay positioning */\n}\n\n/* Prevent text selection and pointer events during resize */\n.edit-content-layout.resizing {\n  user-select: none;\n  cursor: col-resize !important;\n}\n\n.edit-content-layout.resizing * {\n  user-select: none;\n  pointer-events: none !important;\n}\n\n/* Keep the resize handle interactive during resize */\n.edit-content-layout.resizing .resize-handle {\n  pointer-events: auto !important;\n}\n\n/* Add overlay during resize to capture all mouse events */\n.edit-content-layout.resizing::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 9999;\n  cursor: col-resize;\n  pointer-events: auto;\n}\n\n.edit-preview-section {\n  display: flex;\n  flex-direction: column;\n  padding-right: 20px;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.edit-preview-section h3 {\n  margin: 0 0 15px 0;\n  color: #333;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.edit-form-section {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  max-height: calc(100vh - 120px); /* Constrain to viewport height minus modal padding */\n  overflow-y: auto; /* Enable scrolling when content exceeds height */\n}\n\n/* Resize handle between preview and form sections */\n.resize-handle {\n  width: 8px;\n  background-color: #e9ecef;\n  cursor: col-resize;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-left: 1px solid #dee2e6;\n  border-right: 1px solid #dee2e6;\n  transition: background-color 0.2s ease;\n  flex: 0 0 8px;\n}\n\n.resize-handle:hover {\n  background-color: #007bff;\n}\n\n.resize-handle-line {\n  width: 2px;\n  height: 40px;\n  background-color: #6c757d;\n  border-radius: 1px;\n  pointer-events: none;\n}\n\n.resize-handle:hover .resize-handle-line {\n  background-color: white;\n}\n\n/* Resize handle between preview and form sections */\n.resize-handle {\n  width: 8px;\n  background-color: #e9ecef;\n  cursor: col-resize;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-left: 1px solid #dee2e6;\n  border-right: 1px solid #dee2e6;\n  transition: background-color 0.2s ease;\n  flex: 0 0 8px;\n}\n\n.resize-handle:hover {\n  background-color: #007bff;\n}\n\n.resize-handle-line {\n  width: 2px;\n  height: 40px;\n  background-color: #6c757d;\n  border-radius: 1px;\n  pointer-events: none;\n}\n\n.resize-handle:hover .resize-handle-line {\n  background-color: white;\n}\n\n/* Document preview toggle */\n.document-preview-toggle {\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.preview-toggle-btn {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  padding: 10px 20px;\n  font-size: 14px;\n  color: #495057;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.preview-toggle-btn:hover {\n  background-color: #e9ecef;\n  border-color: #adb5bd;\n}\n\n/* Document preview section (when expanded) */\n.document-preview-section {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 20px;\n  height: 400px;\n  display: flex;\n  flex-direction: column;\n}\n\n.document-preview-container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0; /* Allow iframe to shrink */\n  height: 100%;\n}\n\n.document-preview-wrapper {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  gap: 8px;\n}\n\n.pdf-viewer-container {\n  flex: 1;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  background-color: #f5f5f5;\n  min-height: 300px;\n  position: relative;\n}\n\n.document-preview-embed {\n  width: 100%;\n  height: 100%;\n  min-height: 300px;\n  border: none;\n  border-radius: 4px;\n}\n\n.pdf-fallback-message {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 300px;\n  text-align: center;\n  color: #666;\n  padding: 20px;\n}\n\n.pdf-fallback-message p {\n  margin: 8px 0;\n}\n\n.preview-fallback-actions {\n  display: flex;\n  gap: 8px;\n  justify-content: center;\n  padding: 8px;\n}\n\n.open-pdf-btn,\n.download-pdf-btn {\n  padding: 6px 12px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  text-decoration: none;\n  font-size: 12px;\n  transition: background-color 0.2s;\n}\n\n.open-pdf-btn:hover,\n.download-pdf-btn:hover {\n  background-color: #0056b3;\n}\n\n.download-pdf-btn {\n  background-color: #28a745;\n}\n\n.download-pdf-btn:hover {\n  background-color: #1e7e34;\n}\n\n.preview-loading,\n.preview-error,\n.no-preview {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  text-align: center;\n  padding: 40px;\n  background-color: #ffffff;\n  border: 1px dashed #ccc;\n  border-radius: 4px;\n  color: #666;\n}\n\n.retry-preview-btn,\n.load-preview-btn {\n  margin-top: 10px;\n  padding: 8px 16px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.retry-preview-btn:hover,\n.load-preview-btn:hover {\n  background-color: #0056b3;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .document-preview-section {\n    height: 300px;\n  }\n\n  .document-preview-iframe {\n    min-height: 250px;\n  }\n}\n\n.edit-form {\n  display: flex;\n  flex-direction: column;\n  gap: 25px;\n}\n\n.form-section {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  padding: 20px;\n}\n\n/* Constrain supporting sections but allow payroll form to use full width */\n.form-section.document-info-section,\n.form-section.metadata-history-section {\n  margin: 0 auto;\n  max-width: 800px;\n  flex: 0 0 auto; /* Prevent flex growing to fill available space */\n}\n\n/* Keep WH-347 form at full width with horizontal scroll */\n.form-section.payroll-form-section {\n  width: 100%;\n  max-width: none;\n  overflow-x: auto; /* Enable horizontal scroll for wide tables */\n}\n\n/* Collapsible section styles */\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  user-select: none;\n  margin-bottom: 15px;\n  padding: 10px 0;\n  border-bottom: 2px solid #007bff;\n}\n\n.section-header:hover {\n  background-color: rgba(0, 123, 255, 0.05);\n  border-radius: 4px;\n  padding: 10px 8px;\n  margin: 0 -8px 15px -8px;\n}\n\n.section-header h3 {\n  margin: 0;\n  color: #495057;\n  font-size: 18px;\n  font-weight: 600;\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.collapse-icon {\n  font-size: 14px;\n  transition: transform 0.2s ease;\n  color: #007bff;\n  font-weight: bold;\n}\n\n.collapse-icon.collapsed {\n  transform: rotate(90deg);\n}\n\n.section-content {\n  animation: slideDown 0.2s ease-out;\n}\n\n/* Only enable horizontal scroll for payroll form content */\n.payroll-form-section .section-content {\n  overflow-x: auto; /* Enable horizontal scroll for wide tables */\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    max-height: 0;\n    overflow: hidden;\n  }\n  to {\n    opacity: 1;\n    max-height: none;\n    overflow: visible;\n  }\n}\n\n/* Vertical resize handles for sections */\n.section-resize-handle {\n  height: 8px;\n  background-color: #f8f9fa;\n  cursor: row-resize;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-top: 1px solid #dee2e6;\n  border-bottom: 1px solid #dee2e6;\n  transition: background-color 0.2s ease;\n  margin: 5px 0;\n}\n\n.section-resize-handle:hover {\n  background-color: #007bff;\n}\n\n.section-resize-line {\n  width: 40px;\n  height: 2px;\n  background-color: #6c757d;\n  border-radius: 1px;\n  pointer-events: none;\n}\n\n.section-resize-handle:hover .section-resize-line {\n  background-color: white;\n}\n\n/* Modal header improvements */\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.modal-header-controls {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.help-tooltip {\n  font-size: 16px;\n  cursor: help;\n  opacity: 0.7;\n  transition: opacity 0.2s ease;\n}\n\n.help-tooltip:hover {\n  opacity: 1;\n}\n\n/* Legacy h3 styles for non-collapsible sections */\n.form-section h3:not(.section-header h3) {\n  margin: 0 0 20px 0;\n  color: #495057;\n  font-size: 18px;\n  font-weight: 600;\n  border-bottom: 2px solid #007bff;\n  padding-bottom: 8px;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n/* Document Information section layout */\n.form-section:first-of-type .form-group {\n  margin-bottom: 15px;\n}\n\n.form-section:first-of-type h3 {\n  margin-bottom: 15px;\n}\n\n/* Create a 2-column layout for document info fields */\n.document-info-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 15px;\n}\n\n.document-info-full-width {\n  grid-column: 1 / -1;\n}\n\n.form-group label {\n  display: block;\n  font-weight: bold;\n  color: #495057;\n  margin-bottom: 5px;\n  font-size: 14px;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  font-size: 14px;\n  background-color: white;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  box-sizing: border-box;\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #80bdff;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n.metadata-description {\n  font-size: 14px;\n  color: #6c757d;\n  margin-bottom: 15px;\n  font-style: italic;\n}\n\n.metadata-form {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 15px;\n  padding: 10px;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  background-color: #ffffff;\n}\n\n.metadata-display {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.metadata-item {\n  background-color: #ffffff;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  padding: 15px;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.metadata-item strong {\n  color: #495057;\n}\n\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 15px;\n  padding-top: 20px;\n  border-top: 1px solid #dee2e6;\n  margin-top: 10px;\n}\n\n.cancel-btn {\n  padding: 10px 20px;\n  border: 1px solid #6c757d;\n  background-color: #ffffff;\n  color: #6c757d;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.15s ease-in-out;\n}\n\n.cancel-btn:hover {\n  background-color: #6c757d;\n  color: white;\n}\n\n.submit-btn {\n  padding: 10px 20px;\n  border: none;\n  background-color: #007bff;\n  color: white;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background-color 0.15s ease-in-out;\n}\n\n.submit-btn:hover:not(:disabled) {\n  background-color: #0056b3;\n}\n\n.submit-btn:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n}\n\n/* Reject button styling */\n.reject-btn {\n  padding: 10px 20px;\n  border: none;\n  background-color: #dc3545;\n  color: white;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background-color 0.15s ease-in-out;\n}\n\n.reject-btn:hover:not(:disabled) {\n  background-color: #c82333;\n}\n\n.reject-btn:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n}\n\n/* Approve button styling */\n.approve-btn {\n  padding: 10px 20px;\n  border: none;\n  background-color: #28a745;\n  color: white;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background-color 0.15s ease-in-out;\n}\n\n.approve-btn:hover:not(:disabled) {\n  background-color: #218838;\n}\n\n.approve-btn:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n}\n\n/* Save Correction Comments button styling */\n.save-comments-section {\n  margin-top: 10px;\n  margin-bottom: 0;\n}\n\n.save-comments-btn {\n  background-color: #17a2b8;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  font-size: 14px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n  font-weight: 500;\n}\n\n.save-comments-btn:hover:not(:disabled) {\n  background-color: #138496;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.save-comments-btn:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n/* Correction comments display styling */\n.correction-comments-list {\n  margin-top: 8px;\n  margin-left: 10px;\n}\n\n.correction-comment-item {\n  background-color: #f8f9fa;\n  border-left: 3px solid #17a2b8;\n  padding: 8px 12px;\n  margin-bottom: 8px;\n  border-radius: 0 4px 4px 0;\n}\n\n.correction-comment-item:last-child {\n  margin-bottom: 0;\n}\n\n.comment-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 4px;\n  font-size: 12px;\n  color: #6c757d;\n}\n\n.comment-user {\n  font-weight: 600;\n  color: #495057;\n}\n\n.comment-timestamp {\n  font-style: italic;\n}\n\n.comment-text {\n  color: #495057;\n  line-height: 1.4;\n  font-size: 14px;\n}\n\n/* Read-only field styling */\n.readonly-field {\n  padding: 10px 12px;\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  color: #495057;\n  font-size: 14px;\n}\n\n/* Status badge styling */\n.status-badge {\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  display: inline-block;\n  min-width: 60px; /* Ensure consistent minimum width */\n  text-align: center; /* Center text within badge */\n}\n\n.status-badge.processing {\n  background-color: #007bff;\n  color: white;\n}\n\n.status-badge.approved {\n  background-color: #28a745;\n  color: white;\n}\n\n.status-badge.rejected {\n  background-color: #dc3545;\n  color: white;\n}\n\n.status-badge.review_required {\n  background-color: #ffc107;\n  color: #212529;\n}\n\n.status-badge.error {\n  background-color: #dc3545;\n  color: white;\n}\n\n/* Review history styling */\n.review-history {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  padding: 12px;\n  max-height: 300px; /* Limit height to prevent excessive expansion */\n  overflow-y: auto; /* Enable scrolling for long review histories */\n}\n\n.review-entry {\n  margin-bottom: 12px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.review-entry:last-child {\n  margin-bottom: 0;\n  padding-bottom: 0;\n  border-bottom: none;\n}\n\n.review-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.review-status {\n  font-weight: 600;\n  color: #495057;\n}\n\n.review-date {\n  font-size: 12px;\n  color: #6c757d;\n}\n\n.review-comments {\n  font-size: 14px;\n  color: #495057;\n  margin-bottom: 4px;\n}\n\n.correction-comments {\n  font-size: 14px;\n  color: #495057;\n  font-style: italic;\n}\n\n.reviewer-info {\n  margin-top: 4px;\n}\n\n.reviewer-info small {\n  color: #6c757d;\n  font-size: 12px;\n}\n\n/* Correction comments section styling */\n.correction-comments-section {\n  border-top: 2px solid #dee2e6;\n  margin-top: 20px;\n  padding-top: 20px;\n}\n\n.correction-comments-field {\n  margin-bottom: 0;\n}\n\n/* WH-347 Form Specific Styles */\n.wh347-form {\n  max-width: none;\n}\n\n.form-header {\n  text-align: center;\n  margin-bottom: 30px;\n  padding: 20px;\n  background-color: #f8f9fa;\n  border: 2px solid #007bff;\n  border-radius: 8px;\n}\n\n.form-header h3 {\n  margin: 0;\n  color: #007bff;\n  font-size: 20px;\n  font-weight: bold;\n}\n\n.project-info {\n  background-color: #e7f1ff;\n  border-left: 4px solid #007bff;\n}\n\n.employees-section {\n  background-color: #fff5e6;\n  border-left: 4px solid #ffc107;\n}\n\n.signature-section {\n  background-color: #e8f5e8;\n  border-left: 4px solid #28a745;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 15px;\n  margin-bottom: 15px;\n}\n\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.section-header h4, .section-header h6 {\n  margin: 0;\n  color: #495057;\n}\n\n.add-employee-btn, .add-day-btn {\n  padding: 8px 16px;\n  background-color: #28a745;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background-color 0.15s ease-in-out;\n}\n\n.add-employee-btn:hover, .add-day-btn:hover {\n  background-color: #218838;\n}\n\n.employee-card {\n  background-color: white;\n  border: 2px solid #dee2e6;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 20px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.employee-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding-bottom: 10px;\n  border-bottom: 2px solid #ffc107;\n}\n\n.employee-header h5 {\n  margin: 0;\n  color: #495057;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.remove-employee-btn {\n  padding: 6px 12px;\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 500;\n  transition: background-color 0.15s ease-in-out;\n}\n\n.remove-employee-btn:hover {\n  background-color: #c82333;\n}\n\n.employee-info, .pay-info-section, .deductions-section {\n  margin-bottom: 20px;\n}\n\n.days-worked-section {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  padding: 15px;\n  margin-bottom: 20px;\n}\n\n.day-worked-row {\n  display: grid;\n  grid-template-columns: 120px 150px 1fr 1fr;\n  gap: 10px;\n  margin-bottom: 10px;\n  padding: 10px;\n  background-color: white;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n}\n\n.pay-info-section h6, .deductions-section h6 {\n  margin: 0 0 15px 0;\n  color: #495057;\n  font-size: 14px;\n  font-weight: bold;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.generic-metadata-form {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 15px;\n}\n\n.contractor-selection {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  padding: 15px;\n  margin-bottom: 20px;\n}\n\n.radio-group {\n  display: flex;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.radio-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: normal;\n  cursor: pointer;\n  padding: 8px 12px;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  background-color: white;\n  transition: all 0.15s ease-in-out;\n}\n\n.radio-label:hover {\n  background-color: #f8f9fa;\n  border-color: #007bff;\n}\n\n.radio-label input[type=\"radio\"] {\n  width: auto;\n  margin: 0;\n  padding: 0;\n}\n\n.radio-label input[type=\"radio\"]:checked + span,\n.radio-label:has(input[type=\"radio\"]:checked) {\n  background-color: #007bff;\n  color: white;\n  border-color: #007bff;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .edit-modal {\n    width: 98%;\n    max-height: 95vh;\n  }\n\n  .form-section {\n    padding: 15px;\n  }\n\n  .form-section h3 {\n    font-size: 16px;\n  }\n\n  .form-actions {\n    flex-direction: column;\n  }\n\n  .cancel-btn,\n  .submit-btn {\n    width: 100%;\n    padding: 12px;\n  }\n\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n\n  .day-worked-row {\n    grid-template-columns: 1fr;\n  }\n\n  .section-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n\n  .employee-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n}\n\n.help-text {\n  display: block;\n  font-size: 12px;\n  color: #666;\n  margin-top: 4px;\n  line-height: 1.4;\n}\n\n/* Legacy WH-347 Form Styles */\n.wh347-legacy-form {\n  background: #f9f9f9;\n  padding: 20px;\n  font-family: Arial, sans-serif;\n}\n\n.legacy-header {\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.project-info-legacy {\n  margin: 0 auto 20px auto;\n  padding: 15px;\n  background: white;\n  border: 1px solid #ddd;\n  max-width: 800px;\n  border-radius: 4px;\n}\n\n.wh347-legacy-table {\n  width: 100%;\n  min-width: 800px; /* Ensure minimum width to trigger horizontal scroll */\n  border-collapse: collapse;\n  margin: 20px 0;\n  background: white;\n  font-size: 12px;\n}\n\n.wh347-legacy-table th,\n.wh347-legacy-table td {\n  border: 1px solid #000;\n  padding: 2px;\n  vertical-align: top;\n  position: relative;\n}\n\n/* Specific cell width constraints to prevent overflow */\n.name-title-col {\n  width: 200px;\n  min-width: 150px;\n}\n\n.hours-rate-col {\n  width: 140px;\n  min-width: 100px;\n}\n\n.wh347-legacy-table th {\n  background: #f0f0f0;\n  font-weight: bold;\n  text-align: center;\n}\n\n.day-header-table,\n.deduction-header-table,\n.legacy-hours-table,\n.legacy-rate-table,\n.legacy-benefit-table,\n.legacy-deductions-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.day-header-table td,\n.deduction-header-table td {\n  border: 1px solid #ccc;\n  padding: 2px;\n  text-align: center;\n  font-size: 10px;\n}\n\n.legacy-name-input,\n.legacy-title-input,\n.legacy-ssn-input,\n.legacy-exemptions-input,\n.legacy-daily-hours,\n.legacy-hours-input,\n.legacy-rate-input,\n.legacy-wages-input,\n.legacy-deduction,\n.legacy-gross-other,\n.legacy-net-pay,\n.legacy-note-input {\n  width: 100%;\n  border: 1px solid #ccc;\n  padding: 2px;\n  font-size: 11px;\n  margin: 0;\n  box-sizing: border-box;\n  min-width: 0;\n}\n\n/* Dynamic sizing inputs using character width units */\n.legacy-daily-hours {\n  width: max(4ch, 35px);\n  min-width: 60px;\n  max-width: 120px;\n  box-sizing: border-box;\n}\n\n.legacy-ssn-input,\n.legacy-exemptions-input {\n  width: max(4ch, 40px);\n  min-width: 60px;\n  max-width: 80px;\n  box-sizing: border-box;\n}\n\n.legacy-hours-input {\n  width: max(6ch, 60px);\n  min-width: 80px;\n  max-width: 120px;\n  box-sizing: border-box;\n}\n\n.legacy-rate-input,\n.legacy-wages-input {\n  width: max(7ch, 70px);\n  min-width: 90px;\n  max-width: 140px;\n  box-sizing: border-box;\n}\n\n.legacy-deduction {\n  width: max(5ch, 50px);\n  min-width: 30px;\n  max-width: 90px;\n  box-sizing: border-box;\n}\n\n.legacy-benefit-input {\n  width: max(4ch, 45px);\n  min-width: 55px;\n  max-width: 80px;\n  box-sizing: border-box;\n}\n\n.legacy-gross-other {\n  width: max(5ch, 50px);\n  min-width: 60px;\n  max-width: 90px;\n  box-sizing: border-box;\n}\n\n.legacy-net-pay {\n  width: max(7ch, 70px);\n  min-width: 100px;\n  max-width: 150px;\n  box-sizing: border-box;\n}\n\n/* Specific adjustments for name and title fields that tend to overflow */\n.legacy-name-input {\n  min-height: 20px;\n}\n\n.legacy-title-input {\n  min-height: 20px;\n}\n\n.hour-type-label,\n.rate-type-label {\n  font-weight: bold;\n  text-align: center;\n  width: 20px;\n}\n\n.total-hours,\n.gross-pay,\n.total-deductions {\n  font-weight: bold;\n  text-align: right;\n}\n\n.project-label {\n  text-align: right;\n  font-size: 10px;\n}\n\n.hours-worked-label {\n  text-align: center;\n  font-size: 10px;\n  margin-top: 5px;\n  font-weight: bold;\n}\n\n.legacy-employee-management {\n  margin: 20px 0;\n  text-align: center;\n}\n\n.legacy-add-btn,\n.legacy-clear-btn,\n.legacy-remove-btn {\n  background: #4CAF50;\n  color: white;\n  border: none;\n  padding: 8px 15px;\n  margin: 0 5px;\n  cursor: pointer;\n  border-radius: 3px;\n}\n\n.legacy-remove-btn {\n  background: #f44336;\n  padding: 4px 8px;\n  font-size: 10px;\n}\n\n.legacy-additional-options {\n  margin: 20px auto 0 auto;\n  padding: 15px;\n  background: white;\n  border: 1px solid #ddd;\n  max-width: 800px;\n  border-radius: 4px;\n}\n\n/* Project Information form layout */\n.project-info-legacy .form-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 15px;\n  margin-bottom: 15px;\n}\n\n.project-info-legacy .form-group {\n  flex: 1;\n  min-width: 200px;\n}\n\n.project-info-legacy .form-group label {\n  display: block;\n  font-weight: bold;\n  margin-bottom: 5px;\n  font-size: 12px;\n}\n\n.project-info-legacy .form-group input,\n.project-info-legacy .form-group select {\n  width: 100%;\n  padding: 5px;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  font-size: 12px;\n}\n\n/* Additional Options form layout */\n.legacy-additional-options .form-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  margin-bottom: 15px;\n}\n\n.legacy-additional-options .checkbox-group {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.legacy-additional-options .checkbox-group input[type=\"checkbox\"] {\n  width: auto;\n}\n\n.legacy-additional-options .form-group {\n  width: 100%;\n}\n\n.legacy-additional-options .form-group label {\n  display: block;\n  font-weight: bold;\n  margin-bottom: 5px;\n  font-size: 12px;\n}\n\n.legacy-additional-options .form-group textarea {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  font-size: 12px;\n  resize: vertical;\n}\n\n.legacy-gross-summary {\n  width: 100%;\n  font-size: 10px;\n  margin-top: 10px;\n}\n\n.legacy-gross-summary td {\n  padding: 2px;\n  border: 1px solid #ccc;\n}\n\n.summary-header {\n  font-weight: bold;\n  text-align: center;\n}\n\n.note-section {\n  margin-top: 5px;\n  font-size: 10px;\n}\n\n.legacy-label {\n  font-size: 10px;\n  font-weight: bold;\n}\n\n/* Auto-calculation prompt modal styles */\n.calculation-prompt-overlay {\n  z-index: 2000; /* Higher than main modal */\n}\n\n.calculation-prompt-modal {\n  max-width: 500px;\n  width: 90%;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n}\n\n.calculation-prompt-modal .modal-header {\n  background-color: #007bff;\n  color: white;\n  border-radius: 8px 8px 0 0;\n}\n\n.calculation-prompt-modal .modal-header h3 {\n  margin: 0;\n  font-size: 18px;\n}\n\n.calculation-prompt-modal .close-button {\n  color: white;\n}\n\n.calculation-prompt-modal .close-button:hover {\n  color: #fff;\n  opacity: 0.8;\n}\n\n.calculation-preview {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  padding: 15px;\n  margin: 15px 0;\n}\n\n.calculation-preview ul {\n  margin: 10px 0 0 0;\n  padding-left: 20px;\n}\n\n.calculation-preview li {\n  margin: 5px 0;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.btn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: bold;\n  transition: background-color 0.2s ease;\n}\n\n.btn-primary {\n  background-color: #007bff;\n  color: white;\n}\n\n.btn-primary:hover {\n  background-color: #0056b3;\n}\n\n.btn-secondary {\n  background-color: #6c757d;\n  color: white;\n}\n\n.btn-secondary:hover {\n  background-color: #545b62;\n}\n\n/* Legacy gross pay input styling */\n.legacy-gross-input {\n  width: 60px;\n  padding: 2px 4px;\n  border: 1px solid #ccc;\n  border-radius: 2px;\n  font-size: 11px;\n  text-align: right;\n  background-color: #fff;\n}\n\n.legacy-gross-input:focus {\n  border-color: #007bff;\n  outline: none;\n  background-color: #f8f9fa;\n}\n\n/* New CSS classes for API schema field mapping */\n/* Wage inputs - larger for monetary values */\n.legacy-ot-wages-input,\n.legacy-std-wages-input {\n  width: max(7ch, 70px);\n  min-width: 90px;\n  max-width: 140px;\n  box-sizing: border-box;\n  border: 1px solid #ccc;\n  padding: 2px;\n  font-size: 11px;\n  margin: 0;\n}\n\n/* Deduction inputs - medium sized for smaller values */\n.legacy-deduction-fica,\n.legacy-deduction-witholdingTax,\n.legacy-deduction-other,\n.legacy-deduction-healthInsurance,\n.legacy-deduction-retirement_401k {\n  width: max(4ch, 50px);\n  min-width: 60px;\n  max-width: 90px;\n  box-sizing: border-box;\n  border: 1px solid #ccc;\n  padding: 2px;\n  font-size: 11px;\n  margin: 0;\n}\n\n/* Responsive design for edit layout */\n@media (max-width: 768px) {\n  .edit-content-layout {\n    flex-direction: column !important;\n    height: auto;\n  }\n\n  .edit-preview-section {\n    border-right: none;\n    border-bottom: 1px solid #dee2e6;\n    padding-right: 0;\n    padding-bottom: 20px;\n    margin-bottom: 20px;\n  }\n\n  .document-preview-iframe {\n    height: 400px;\n  }\n\n  .calculation-prompt-modal {\n    max-width: 95%;\n  }\n\n  .modal-actions {\n    flex-direction: column;\n  }\n\n  .btn {\n    width: 100%;\n    margin: 5px 0;\n  }\n}\n\n/* Validation Error Highlighting Styles */\n.field-error {\n  border: 2px solid #dc3545 !important;\n  background-color: #f8d7da !important;\n  color: #721c24 !important;\n}\n\n.field-error-label {\n  color: #dc3545 !important;\n  font-weight: bold;\n}\n\n.field-error-icon {\n  color: #dc3545;\n  margin-left: 5px;\n  font-weight: bold;\n}\n\n.validation-error-summary {\n  background-color: #f8d7da;\n  border: 1px solid #f5c6cb;\n  border-radius: 4px;\n  padding: 10px;\n  margin-bottom: 15px;\n  color: #721c24;\n}\n\n.validation-error-summary h5 {\n  color: #721c24;\n  margin-bottom: 10px;\n  font-size: 14px;\n}\n\n.validation-error-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.validation-error-list li {\n  padding: 2px 0;\n  font-size: 12px;\n}\n\n.validation-error-list li:before {\n  content: \"⚠ \";\n  color: #dc3545;\n  font-weight: bold;\n}\n\n/* Upload-result styling for error messages (matching DocumentUpload.css) */\n.upload-result {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 15px;\n  border-radius: 4px;\n  margin-top: 15px;\n}\n\n.upload-result.success {\n  background: #d4edda;\n  border: 1px solid #c3e6cb;\n  color: #155724;\n}\n\n.upload-result.error {\n  background: #f8d7da;\n  border: 1px solid #f5c6cb;\n  color: #721c24;\n}\n\n.result-icon {\n  font-size: 16px;\n  margin-top: 2px;\n}\n\n.result-message {\n  flex: 1;\n}\n\n/* Button-result styling for status display near action buttons */\n.button-result {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 12px;\n  border-radius: 4px;\n  margin-top: 10px;\n  font-size: 14px;\n}\n\n.button-result.success {\n  background: #d4edda;\n  border: 1px solid #c3e6cb;\n  color: #155724;\n}\n\n.button-result.error {\n  background: #f8d7da;\n  border: 1px solid #f5c6cb;\n  color: #721c24;\n}\n\n.result-details {\n  font-size: 12px;\n  margin-top: 5px;\n  opacity: 0.8;\n}\n\n/* Validation error categories styling */\n.validation-category {\n  margin-bottom: 15px;\n}\n\n.validation-category h6 {\n  margin: 0 0 8px 0;\n  font-weight: bold;\n  font-size: 14px;\n  color: #721c24;\n}\n\n.validation-category ul {\n  margin: 0;\n  padding-left: 20px;\n  list-style: none;\n}\n\n.validation-category li {\n  padding: 2px 0;\n  font-size: 13px;\n  color: #721c24;\n}\n\n.validation-category li:before {\n  content: \"• \";\n  color: #dc3545;\n  font-weight: bold;\n}\n\n/* Rule Replacement Notifications */\n.rule-notification {\n  background-color: #d1ecf1;\n  border: 1px solid #bee5eb;\n  border-radius: 4px;\n  padding: 8px 12px;\n  margin-top: 4px;\n  font-size: 12px;\n  color: #0c5460;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  position: relative;\n  animation: slideInDown 0.3s ease-out;\n}\n\n.rule-notification.just-created {\n  background-color: #d4edda;\n  border-color: #c3e6cb;\n  color: #155724;\n}\n\n.rule-notification-icon {\n  font-size: 14px;\n  flex-shrink: 0;\n}\n\n.rule-notification-content {\n  flex: 1;\n  line-height: 1.3;\n}\n\n.rule-notification-original {\n  text-decoration: line-through;\n  color: #6c757d;\n  font-weight: normal;\n}\n\n.rule-notification-mapped {\n  font-weight: 600;\n  color: #0c5460;\n}\n\n.rule-notification.just-created .rule-notification-mapped {\n  color: #155724;\n}\n\n.rule-notification-dismiss {\n  background: none;\n  border: none;\n  color: #6c757d;\n  cursor: pointer;\n  padding: 0;\n  font-size: 14px;\n  line-height: 1;\n  flex-shrink: 0;\n  margin-left: 4px;\n}\n\n.rule-notification-dismiss:hover {\n  color: #495057;\n}\n\n@keyframes slideInDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Parsing Notes Styles */\n.parsing-notes-group {\n  margin-bottom: 20px;\n}\n\n.parsing-notes-group label {\n  color: #2c3e50;\n  font-weight: 600;\n  margin-bottom: 8px;\n  display: block;\n}\n\n.parsing-notes-container {\n  background: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 6px;\n  padding: 12px;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.parsing-note {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 8px;\n  padding: 6px 8px;\n  background: white;\n  border-radius: 4px;\n  border-left: 3px solid #17a2b8;\n  box-shadow: 0 1px 2px rgba(0,0,0,0.1);\n}\n\n.parsing-note:last-child {\n  margin-bottom: 0;\n}\n\n.note-index {\n  color: #6c757d;\n  font-weight: 600;\n  margin-right: 8px;\n  flex-shrink: 0;\n  min-width: 20px;\n  font-size: 12px;\n}\n\n.note-text {\n  color: #495057;\n  line-height: 1.4;\n  font-size: 14px;\n  word-break: break-word;\n}\n\n/* Special styling for different types of notes */\n.parsing-note-error {\n  border-left-color: #dc3545 !important;\n}\n\n.parsing-note-warning {\n  border-left-color: #ffc107 !important;\n}\n\n.parsing-note-success {\n  border-left-color: #28a745 !important;\n}\n\n.parsing-note-info {\n  border-left-color: #17a2b8 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
